import {
	PNG_BIT_DEPTH_8,
	PNG_COLOR_TYPE_RGBA,
	PNG_COMPRESSION_METHOD_DEFLATE,
	PNG_DEFAULT_IDAT_CHUNK_SIZE,
	PNG_FILTER_METHOD_STANDARD,
	PNG_INTERLACE_NONE
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/export/GenogramExportConstants";

const PNG_SIGNATURE = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10])
const textEncoder = new TextEncoder()
const crcTable = createCrcTable()

export default class GenogramPngChunkHelper {

	getSignatureBytes() {
		return PNG_SIGNATURE
	}

	createIHDRChunk(width, height) {
		let data = new Uint8Array(13)
		let view = new DataView(data.buffer)
		view.setUint32(0, width)
		view.setUint32(4, height)
		data[8] = PNG_BIT_DEPTH_8
		data[9] = PNG_COLOR_TYPE_RGBA
		data[10] = PNG_COMPRESSION_METHOD_DEFLATE
		data[11] = PNG_FILTER_METHOD_STANDARD
		data[12] = PNG_INTERLACE_NONE

		return this.createChunk("IHDR", data)
	}

	createIDATChunks(compressedBytes, chunkSize = PNG_DEFAULT_IDAT_CHUNK_SIZE) {
		let chunks = []
		let offset = 0

		while (offset < compressedBytes.length) {
			let nextOffset = Math.min(offset + chunkSize, compressedBytes.length)
			let chunkData = compressedBytes.slice(offset, nextOffset)
			chunks.push(this.createChunk("IDAT", chunkData))
			offset = nextOffset
		}

		if (chunks.length === 0) {
			chunks.push(this.createChunk("IDAT", new Uint8Array(0)))
		}

		return chunks
	}

	createIENDChunk() {
		return this.createChunk("IEND", new Uint8Array(0))
	}

	createChunk(type, data) {
		let typeBytes = textEncoder.encode(type)
		let lengthBytes = new Uint8Array(4)
		let lengthView = new DataView(lengthBytes.buffer)
		lengthView.setUint32(0, data.length)

		let chunkPayload = new Uint8Array(typeBytes.length + data.length)
		chunkPayload.set(typeBytes, 0)
		chunkPayload.set(data, typeBytes.length)

		let crcBytes = new Uint8Array(4)
		let crcView = new DataView(crcBytes.buffer)
		crcView.setUint32(0, this.calculateCrc32(chunkPayload))

		return new Blob([lengthBytes, chunkPayload, crcBytes], {type: "application/octet-stream"})
	}

	calculateCrc32(bytes) {
		let crc = 0xffffffff

		for (let index = 0; index < bytes.length; index++) {
			let tableIndex = (crc ^ bytes[index]) & 0xff
			crc = crcTable[tableIndex] ^ (crc >>> 8)
		}

		return (crc ^ 0xffffffff) >>> 0
	}
}

function createCrcTable() {
	let table = new Uint32Array(256)

	for (let index = 0; index < table.length; index++) {
		let crc = index
		for (let bit = 0; bit < 8; bit++) {
			let isOdd = (crc & 1) === 1
			crc = isOdd ? (0xedb88320 ^ (crc >>> 1)) : (crc >>> 1)
		}
		table[index] = crc >>> 0
	}

	return table
}
